import { useState, useRef } from "react";
import {
    cssIcon, htmlIcon, expressIcon, jqueryIcon, javaScriptIcon, nodeIcon, mongoDbIcon, reactIcon, phpIcon, linuxIcon,JavaIcon, githubIcon,
    LeftIcon, RightIcon
} from '../Files/svg_icons/index.js';


export default function SkillsAndTech(allProps) {

    const startX = useRef(0);
    const startY = useRef(0);
    const dragging = useRef(false);

    const [techActive, setTechActive] = useState(true);

    const onTechSkillClick = (val) => {
        setTechActive(val);

    }

    const handleTsDragStart = (e) => {
        const touch = e.touches[0];
        startX.current = touch.clientX;
        startY.current = touch.clientY;
        dragging.current = false;
    } 

    const handleTsDragMove = (e, techTrueSkillFalse) => {
        const touch = e.touches[0];
        const dx = touch.clientX - startX.current;
        const dy = touch.clientY - startY.current;

        if (!dragging.current) {
            if (Math.abs(dx) > Math.abs(dy)) {
                // It's a horizontal drag — trigger your event

                dragging.current = true;
                // Prevent vertical scroll
                // onHorizontalDrag(dx);

                if(dx < 0 && (techTrueSkillFalse === false)) {
                    // e.preventDefault();
                    onTechSkillClick(techTrueSkillFalse);
                } else if (dx > 0 && (techTrueSkillFalse === true)) {
                    onTechSkillClick(techTrueSkillFalse);
                }

            } else {
                // Let it scroll normally
                dragging.current = true;
            }
        }
    }

    return (
        <>

        <section className="skill-section" id="skill-section">

            <div className={techActive === true ? "inner-wrapper tech-active" : "inner-wrapper skills-active"}>
                <Tech 
                    section_headings={allProps.section_headings} 
                    techActive={techActive} 
                    onTechSkillClick={onTechSkillClick} 
                    handleTsDragStart={handleTsDragStart}  
                    handleTsDragMove={handleTsDragMove}
                />

                <Skills 
                    section_headings={allProps.section_headings} 
                    mySkills={allProps.mySkills} 
                    techActive={techActive} 
                    onTechSkillClick={onTechSkillClick} 
                    handleTsDragStart={handleTsDragStart}  
                    handleTsDragMove={handleTsDragMove}
                />
                
                <div className="view-more">

                    <button onClick={() => onTechSkillClick(true) } disabled={techActive} > 
                        <img src={LeftIcon} className="left-right-svgs" alt="Left icon" /> 
                        
                    </button>
                    <span
                        className="switch-tech-view"
                        
                    >
                        {techActive === true ? "1" : "2"}
                    </span>

                    <button onClick={() => onTechSkillClick(false) } disabled={!techActive}> 
                        <img src={RightIcon} className="left-right-svgs" alt="Right icon" /> 
                    </button>
                </div>
                

            </div>

            

            
        </section>
        </>
    )
}



function Skills(props) {

    const mySkills = props.mySkills;
    const section_headings = props.section_headings;
    const { technical, softskills, spoken_languages } = mySkills;
    const { language, frontend, backend, misc_database } = technical;


    return (
        <>
            <div id="skills" 
                className="skill-component" 
                // draggable={true} 
                // onDragStart={() => props.onTechSkillClick(true)}

                onTouchStart={(eve) => props.handleTsDragStart(eve)}  
                onTouchMove={(eve) => props.handleTsDragMove(eve, true)}

            >
                <h2>{section_headings.skills}</h2>
                <ul>
                    <li>
                        <h3>{section_headings.language_concepts}</h3>

                        <div className="skill-list">

                            {
                                language.map((lang, langIdx) => (
                                    <span key={langIdx}>{lang}</span>
                                ))
                            }

                        </div>

                    </li>

                    <li>
                        <h3>Frontend</h3>

                        <div className="skill-list">
                            {
                                frontend.map((frSkill, frSkillIdx) => (
                                    <span key={frSkillIdx}>{frSkill}</span>
                                ))
                            }

                        </div>
                    </li>

                    <li>
                        <h3>Backend</h3>

                        <div className="skill-list">
                            {
                                backend.map((bkSkill, bkSkillIdx) => (
                                    <span key={bkSkillIdx}>{bkSkill}</span>
                                ))
                            }

                        </div>
                    </li>

                    <li>
                        <h3>{section_headings.database_tools}</h3>

                        <div className="skill-list">
                            {
                                misc_database.map((dbMscSkill, dbMscSkillIdx) => (
                                    <span key={dbMscSkillIdx}>{dbMscSkill}</span>
                                ))
                            }
                        </div>

                    </li>


                    <li>
                        <h3>{section_headings.soft_skills} </h3>

                        <div className="skill-list">
                            {
                                softskills.map((softSkill, softSkillIdx) => (
                                    <span key={softSkillIdx}>{softSkill}</span>
                                ))
                            }
                        </div>

                    </li>

                    <li>
                        <h3>{section_headings.spoken_languages}</h3>

                        <div className="skill-list">
                            {
                                spoken_languages.map((spokenLang, spokenLangIdx) => (
                                    <span key={spokenLangIdx}>{spokenLang}</span>
                                ))
                            }
                        </div>

                    </li>
                </ul>


            </div>
        </>
    );
}


function Tech (props) {
    
    const allIcons = {HTML: htmlIcon, CSS: cssIcon, Node: nodeIcon, ExpressJs: expressIcon, jQuery: jqueryIcon, 
        JavaScript: javaScriptIcon, MongoDB: mongoDbIcon, React: reactIcon, JAVA: JavaIcon, 
        PHP: phpIcon, Git: githubIcon, Linux: linuxIcon
    };

    const {tech_worked_on} = props.section_headings;


    


    return (
        <>
            <div 
                className={`technology-component`} 
                // draggable={true} 
                // onDragStart={() => props.onTechSkillClick(false)}

                onTouchStart={(eve) => props.handleTsDragStart(eve)}  
                onTouchMove={(eve) => props.handleTsDragMove(eve, false)}
            >
                <h2>{tech_worked_on}</h2>

                <div className='tech-icon-container'>
                {
                    Object.keys(allIcons).map((iconElem, iconIndx) => (
                        <img className='svg-tech-icon' title={iconElem} alt={iconElem} src={allIcons[iconElem]} key={iconIndx} />
                    ))
                }

                </div>
                

                
            </div>
        </>
    );
}

